import { connect, Provider } from 'react-redux';
import { Router } from 'react-router';
import { IntlProvider } from 'react-intl';


@connect(state => ({
  locale: state.locale,
  messages: state.translations,
}))
class IntlWrapper extends React.Component {
  static propTypes = {
    children: React.PropTypes.element,
    locale: React.PropTypes.string,
    messages: React.PropTypes.object,
  };

  render() {
    return (
      <IntlProvider {...this.props} />
    );
  }
}

export default class Root extends React.Component {
  static propTypes = {
    history: React.PropTypes.object.isRequired,
    routes: React.PropTypes.element.isRequired,
    store: React.PropTypes.object.isRequired,
  };

  get content() {
    const { history, routes } = this.props;

    return (
      <IntlWrapper>
        <Router history={history}>
          {routes}
        </Router>
      </IntlWrapper>
    );
  }

  render() {
    return (
      <Provider store={this.props.store}>
        {this.content}
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/root.js